import { render, staticRenderFns } from "./AppellantLeaveRefusedJourneyMap.vue?vue&type=template&id=3961af08&scoped=true"
import script from "./AppellantLeaveRefusedJourneyMap.vue?vue&type=script&lang=ts"
export * from "./AppellantLeaveRefusedJourneyMap.vue?vue&type=script&lang=ts"
import style0 from "./AppellantLeaveRefusedJourneyMap.vue?vue&type=style&index=0&id=3961af08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3961af08",
  null
  
)

export default component.exports